import React from "react";

export const FrigidIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="25" fill="#3F4447">
                <g transform="translate(4.000000, 15.000000)">
                    <path
                        d="M38.5,9.5 C38.5,6.1862915 41.1862915,3.5 44.5,3.5 C47.8137085,3.5 50.5,6.1862915 50.5,9.5 C50.5,12.8137085 47.8137085,15.5 44.5,15.5 L17,15.5 C16.1715729,15.5 15.5,16.1715729 15.5,17 C15.5,17.8284271 16.1715729,18.5 17,18.5 L44.5,18.5 C49.4705627,18.5 53.5,14.4705627 53.5,9.5 C53.5,4.52943725 49.4705627,0.5 44.5,0.5 C39.5294373,0.5 35.5,4.52943725 35.5,9.5 C35.5,10.3284271 36.1715729,11 37,11 C37.8284271,11 38.5,10.3284271 38.5,9.5 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M35.5,40.5 C35.5,45.4705627 39.5294373,49.5 44.5,49.5 C49.4705627,49.5 53.5,45.4705627 53.5,40.5 C53.5,35.5294373 49.4705627,31.5 44.5,31.5 L2,31.5 C1.17157288,31.5 0.5,32.1715729 0.5,33 C0.5,33.8284271 1.17157288,34.5 2,34.5 L44.5,34.5 C47.8137085,34.5 50.5,37.1862915 50.5,40.5 C50.5,43.8137085 47.8137085,46.5 44.5,46.5 C41.1862915,46.5 38.5,43.8137085 38.5,40.5 C38.5,39.6715729 37.8284271,39 37,39 C36.1715729,39 35.5,39.6715729 35.5,40.5 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M62.5,11.5 C65.8137085,11.5 68.5,14.1862915 68.5,17.5 C68.5,20.8137085 65.8137085,23.5 62.5,23.5 L2,23.5 C1.17157288,23.5 0.5,24.1715729 0.5,25 C0.5,25.8284271 1.17157288,26.5 2,26.5 L62.5,26.5 C67.4705627,26.5 71.5,22.4705627 71.5,17.5 C71.5,12.5294373 67.4705627,8.5 62.5,8.5 C61.6715729,8.5 61,9.17157288 61,10 C61,10.8284271 61.6715729,11.5 62.5,11.5 Z"
                        fillRule="nonzero"
                    />
                    <g transform="translate(59.000000, 31.000000)">
                        <rect
                            transform="translate(5.363005, 5.000000) rotate(45.000000) translate(-5.363005, -5.000000) "
                            x="3.86300471"
                            y="0"
                            width="3"
                            height="10"
                            rx="1.5"
                        />
                        <rect
                            transform="translate(5.363005, 5.000000) scale(-1, 1) rotate(45.000000) translate(-5.363005, -5.000000) "
                            x="3.86300471"
                            y="2.27373675e-13"
                            width="3"
                            height="10"
                            rx="1.5"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
